import React from 'react';
import { useNavigate } from 'react-router-dom';

const accountsData = [
  { id: 1, name: 'Designated Beneficiary IN ...690' },
  { id: 2, name: 'Individual ...878' },
  { id: 3, name: 'Individual ...790' },
];

export default function ReviewSelectionSch({ selectedAccounts, onBack }) {
  const navigate = useNavigate();

  const selectedNames = accountsData
    .filter((acc) => selectedAccounts.includes(acc.id))
    .map((acc) => acc.name);

  const handleDone = () => {
    navigate('/broker-success');
  };

  return (
    <>
      {/* Overlay background สีดำโปร่งแสง */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>

      {/* Background สีขาวเต็มจอ */}
      <div className="fixed inset-0 bg-white z-45"></div>

      {/* Modal popup */}
      <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
        <div className="max-w-xl mx-auto p-6 bg-white rounded-lg relative shadow-lg w-full">
          {/* โลโก้อยู่มุมซ้ายบน */}
         

          <h2 className="text-xl font-semibold mb-6 text-center">Review your selected accounts</h2>
          
          <p className="mb-4 text-center text-sm">
            You've selected the following accounts to link to Quantum Flo Auto Algo.
          </p>

          <ul className="list-disc pl-6 mb-6 max-h-48 overflow-y-auto text-sm">
            {selectedNames.map((name, idx) => (
              <li key={idx}>{name}</li>
            ))}
          </ul>

          <p className="mb-6 text-sm text-gray-700 leading-relaxed">
            To stop linking your Schwab accounts to this or any other third party, go to the Schwab Security Center page.<br />
            To complete the account linking and go back to Quantum Flo Auto Algo click done.
          </p>

          <div className="flex justify-between">
            <button
              onClick={onBack}
              className="py-2 px-6 border rounded hover:bg-gray-100"
            >
              Back
            </button>
            <button
              onClick={handleDone}
              className="py-2 px-6 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
